import { DomainRegistry } from "../../../../../domain";
import { FormatTreeSourceBase } from "./FormatTreeSourceBase";

export class PublicFormatTreeSource extends FormatTreeSourceBase {
  constructor() {
    super("公開フォーマット情報", () => DomainRegistry.instance.editableFormat.getPublicFormatRepository());
  }
}
